import { Routes } from '@angular/router';
import { ContentComponent } from './layouts/content/content.component';
import { DashboardLayoutComponent } from './layouts/full/dashboard-layout/dashboard-layout.component';
import { full_routes } from './layouts/routes/full-layout.routes';
import { CONTENT_ROUTES } from './layouts/routes/content-layout.routes';
import { authGuard } from './service/auth/auth-guard.service';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'pages/login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DashboardLayoutComponent,
    children: full_routes,
    canActivate: [authGuard],
  },
  {
    path: '',
    component: ContentComponent,
    children: CONTENT_ROUTES,
  },
  {
    path: '**',
    redirectTo: 'pages/error',
  },
];
